import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactoService {

  constructor(private http: HttpClient) { }

  enviarContacto(formulario: any) {
    return this.http
      .post(`https://www.porunpaismejor.com.mx/desarrollo/simicomentarios/api/Comentarios`, formulario, {
        headers: {
          'Content-Type':'application/json',
          'Accept': 'application/json'
        }
      });
  }

}